export default __webpack_public_path__ + "static/media/franklin-d-roosevelt.0ac844f0.png";